import {
    PLUGIN_FORM_CHANGE,
    PLUGIN_FORM_ERASE,
    PLUGINS_CONVERT_SUBMIT,
    PLUGINS_FILES_SUBMIT,
    PLUGINS_GET_CSV_PREVIEW,
    PLUGINS_WIZARD_CSV_ROW_LIST_CSV_ROWS_GET
} from "./actions";
import {REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS} from "../../../middlewares/api/actions";
import {FILE_MAPPING_WIZARD_CSV_FORM_SUBMIT} from "../../data-manager/file-mapping/wizard/csv-form/actions";
import _ from "lodash";

const pluginsReducer = (
    state = {
        pluginForm: {},
        csvPreview: {},
        csvPreviewParams: {},
        fileServerPath: null,
        secondServerPath: null,
        thirdServerPath: null
    },
    action
) => {
    switch (action.type) {
        case PLUGIN_FORM_ERASE:
            return {
                pluginForm: {},
                csvPreview: {},
                csvPreviewParams: {},
                fileServerPath: null,
                secondServerPath: null,
                thirdServerPath: null
            };
        case PLUGIN_FORM_CHANGE:
            return {
                ...state, pluginForm: {
                    ...state.pluginForm,
                    ..._.mapValues(action.fields, field => field.value)
                },
            };
        case REQUEST_SUCCESS:
            switch (action.label) {
                case PLUGINS_FILES_SUBMIT:
                    const fileServerPath = Array.isArray(action.response) ? action.response[0] : action.response;
                    const secondServerPath = Array.isArray(action.response) ? action.response[1] : null;
                    const thirdServerPath = Array.isArray(action.response) && action.response.length > 2 ? action.response[2] : null;
                    return {
                        ...state,
                        fileServerPath,
                        secondServerPath,
                        thirdServerPath
                    };
                case PLUGINS_CONVERT_SUBMIT:
                    const inputFilePath = action.response.inputFilePath.split("\\");
                    const outputFilePath = action.response.outputFilePath.split("\\");
                    return {
                        ...state, outputFilePath: action.response.outputFilePath,
                        csvPreviewParams: {
                            csvSeparator: action.response.csvSeparator || ",",
                            csvDelimiter: (action.response.csvDelimiter === "\n" ? null : action.response.csvDelimiter) || null,
                            csvHasHeader: action.response.csvHasHeader,
                        },
                        pluginForm: {
                            ...state.pluginForm,
                            response: {
                                inputFilePath: inputFilePath[inputFilePath.length - 1],
                                outputFilePath: outputFilePath[outputFilePath.length - 1],
                                executionTime: action.response.executionTime,
                                rowsProcessed: action.response.rowsProcessed,
                                seriesProcessed: action.response.seriesProcessed,
                                errorMessage: action.response.errorMessage,
                            }
                        },
                        convertError: false
                    };
                case PLUGINS_GET_CSV_PREVIEW:
                    return {...state, csvPreview: action.response};
                case PLUGINS_WIZARD_CSV_ROW_LIST_CSV_ROWS_GET:
                    return {
                        ...state,
                        csvPreview: action.response
                    };
                default:
                    return {...state};
            }
        case REQUEST_START:
            switch (action.label) {
                case FILE_MAPPING_WIZARD_CSV_FORM_SUBMIT:
                    return {
                        ...state,
                        fileServerPath: null,
                        secondServerPath: null,
                        thirdServerPath: null,
                    };
                case PLUGINS_CONVERT_SUBMIT:
                    return {
                        ...state,
                        convertError: false
                    };
                default:
                    return {...state};
            }
        case REQUEST_ERROR:
            switch (action.label) {
                case PLUGINS_WIZARD_CSV_ROW_LIST_CSV_ROWS_GET:
                    return {
                        ...state,
                        csvPreview: null
                    };
                case PLUGINS_CONVERT_SUBMIT:
                    return {
                        ...state,
                        convertError: true
                    }
                default:
                    return {...state}
            }
        default:
            return {...state};
    }
};

export default pluginsReducer;